import { Grid } from "@mui/material";
import React from "react";
import Select from "react-select";
 
const CustomDropDown = ({
  data,
  isSearchable,
  placeholder,
  height,
  selected,
  isDisabled,
  isMulti,
  Value1,
  placement,
  isFixed,
  fontSize,
  isClearable,
  borderColor,
  borderRadius,
  onChange,
  backgroundColor
}) => {
  const selectStyles = {
    control: (provided) => ({
      ...provided,
      height: height ? height : "45px",
      textTransform: "capitalize",
      backgroundColor: backgroundColor? backgroundColor : "transparent",
      borderRadius: borderRadius ? borderRadius : "11px",
      color: "#000",
      border: `1px solid ${borderColor ? "#666666" : "#666666"}`,
      boxShadow: "none",
      "&:hover": {
        border: "1px solid #666666",
        outline: "none"
      },
 
    }),
    placeholder: (provided) => ({
      ...provided,
      textAlign: "left",
      fontSize: fontSize ? fontSize : "clamp(10px, 4vw, 13px)",
      color: "#8a8a8a",
      fontFamily: "PoppinsMedium",
      fontWeight: 500,
      backgroundColor: "transparent",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
    }),
    option: (provided,state) => ({
      ...provided,
      textAlign: "left",
      fontSize: fontSize ? fontSize : "clamp(10px, 4vw, 13px)",
      color: "#000",
      fontFamily: "PoppinsMedium",
      fontWeight: 500,
      textTransform: "capitalize",
      backgroundColor: state.isSelected
        ? "#f0f0f0"
        : state.isFocused
          ? "#e0e0e0"
          : "#fff",
      marginTop: "2px",
    }),
    multiValue: (provided) => ({
      ...provided,
      textAlign: "left",
      fontSize: fontSize ? fontSize : "clamp(10px, 4vw, 13px)",
      fontFamily: "PoppinsMedium",
      color: "#000",
      backgroundColor: "#000",
    }),
    input: (provided) => ({
      ...provided,
      color: "#000", 
      fontSize: fontSize ? fontSize : "clamp(10px, 4vw, 13px)",
      fontFamily: "PoppinsMedium",
    }),
    singleValue: (provided) => ({
      ...provided,
      textAlign: "left",
      fontSize: fontSize ? fontSize : "clamp(10px, 4vw, 13px)",
      fontFamily: "PoppinsMedium",
      textTransform: "capitalize",
      color: "#000",
      backgroundColor: "transparent",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 2010,
      backgroundColor: "#fff",
      border: "1px solid #fff",
      color: "#000",
      position: isFixed ? "unset" : "absolute",
      maxHeight: "200px",
      overflowY: "hidden",
      scrollbarWidth: "thin",
      className: "CustomScroll",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "200px",
      overflowY: "auto",
      scrollbarWidth: "thin",  
      className: "CustomScroll",
    }),
  };
 
  const Formatlabel = (data) => {
    return (
      <Grid
        container
        display={"flex"}
        flexDirection={"row"}
        alignItems={"center"}
        justifyContent={"flex-start"}
      >
        <Grid item>
          <p>{data.label}</p>
        </Grid>
 
      </Grid>
    );
  };
 
  return (
    <Select
      value={selected ? selected : null}
      inputProps={Value1}
      isSearchable={isSearchable ? true : false}
      options={data}
      classNamePrefix="my-select"
      styles={selectStyles}
      onChange={(option) => onChange(option)}
      placeholder={placeholder || "Select"}
      className="w-100"
      isDisabled={isDisabled ? isDisabled : false}
      isMulti={isMulti}
      menuPlacement={placement ? placement : "auto"}
      menuPosition={ isFixed? "unset":""}
      isClearable={isClearable ? true : false}
      menuShouldScrollIntoView={"true"}
      formatOptionLabel={(data) => Formatlabel(data)}
    />
  );
};
export default CustomDropDown;